module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "verify"
    }
  }, [(!_vm.token) ? _c('div', [(!_vm.verificationRequestSent) ? _c('div', [_c('h1', [_vm._v("Before you proceed")]), _vm._v(" "), _c('p', [_vm._v("For your security, please confirm your email address in order to verify your account.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestVerificationEmail()
      }
    }
  }, [_vm._v("Send Verification Email")])]) : _vm._e(), _vm._v(" "), (_vm.verificationRequestSent) ? _c('div', [_c('h2', [_vm._v("Please check your email")]), _vm._v(" "), _c('p', [_vm._v("Look for a message from \"Lewis Rice Estate Planning Portal\" containing a verification link. Click the link in the email to complete your account set up.")]), _vm._v(" "), _c('p', [_vm._v("If you do not receive the verification email, please check your Spam or Junk E-Mail folder, or request another verification email.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestVerificationEmail()
      }
    }
  }, [_vm._v("Re-Send Verification Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.token) ? _c('div', [(!_vm.tokenVerificationComplete) ? _c('div', [_c('h1', [_vm._v("Verifying...")]), _vm._v(" "), (_vm.tokenVerificationFailed) ? _c('div', [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestVerificationEmail()
      }
    }
  }, [_vm._v("Re-Send Verification Email")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tokenVerificationComplete) ? _c('div', [_c('h1', [_vm._v("Account Verified")]), _vm._v(" "), _c('p', [_vm._v("Your account is now verified and fully activated. You may now view, download, and share your estate planning documents.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }, [_vm._v("View My Documents")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Be sure to bookmark "), _c('a', {
    attrs: {
      "href": "https://www.lrepdocs.com"
    }
  }, [_vm._v("https://www.lrepdocs.com")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3604e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verify.vue
// module id = 289
// module chunks = 1